import React from "react";
import ReactDOM from "react-dom";
import { Section, Box, Heading, Paragraph, Image } from "grommet";

import titleImage from "./title.jpg";

const SensorToolkit = props => (
  <Section colorIndex={props.colorIndex} pad="medium" align="center">
    {!props.responsive ? (
      <Heading tag="h2" strong={true} margin="small">
        Sensor Toolkit
      </Heading>
    ) : null}
    <Box direction="row" size={{ width: "xxlarge" }}>
      <Box direction="column" basis="2/3" margin="small" textAlign="left">
        <br />
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/37z6hTHuJRI?rel=0"
          frameborder="0"
          allow="autoplay; encrypted-media"
          allowfullscreen
        />
        <Paragraph>
          Sensor Toolkit is an asset I've made for the Unity asset store. It has
          a collection of sensor components which provide a convenient
          abstraction over Unity's basic sensing functionality like ray casts
          and trigger colliders. For advanced use cases it includes field of
          view cones (a feature missing in Unity), line of sight calculations
          and steering behaviour.
        </Paragraph>
        <Paragraph>
          I made Sensor Toolkit because I found myself always writing the same
          code in Unity. Almost every game needs to implement sensors in some
          way. For example:
        </Paragraph>
        <ul>
          <li>What's the nearest coin to my character.</li>
          <li>Is my character standing on the ground.</li>
          <li>Can a guard see my character.</li>
        </ul>
        <Paragraph>
          Unity provides some basic tools for scripting this behaviour, but they
          can be a real pain to write and very frustrating to debug. Sensor
          Toolkit tries to replace these basic tools with a more convenient set
          of concepts and thorough debugging and visualisation tools.
        </Paragraph>
      </Box>
      <Box direction="column" basis="1/3" justify="left" textAlign="left">
        <Paragraph>
          Unfortunately Sensor Toolkit hasn't made me rich, but it has
          maintained a 5 star average rating on the asset store and many regular
          users. I'm very happy with how Sensor Toolkit has developed and I
          would use it in all my future Unity projects.
        </Paragraph>
        <Image src={titleImage} size="medium" />
        <Paragraph size="small">
          If you'd like to know more you can go to the Sensor Toolkit website{" "}
          <a href="/sensortoolkit">here</a>
        </Paragraph>
      </Box>
    </Box>
  </Section>
);

export default SensorToolkit;



// WEBPACK FOOTER //
// ./src/components/projects/sensor-toolkit/sensor-toolkit.js